import { render, staticRenderFns } from "./targeting.vue?vue&type=template&id=22fe5426&scoped=true"
import script from "./targeting.vue?vue&type=script&lang=js"
export * from "./targeting.vue?vue&type=script&lang=js"
import style0 from "./targeting.vue?vue&type=style&index=0&id=22fe5426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe5426",
  null
  
)

export default component.exports